// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-criminal-grid-table .settingsContainer {
  border-top: 1px solid;
  padding-top: 20px;
  padding-bottom: 2px;
}
app-criminal-grid-table .mat-tab-label {
  background-color: #e6e4e6;
  width: 50%;
}
app-criminal-grid-table .gridHeaderContainer {
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  padding-bottom: 20px;
}
app-criminal-grid-table .gridHeaderContainer .headerContainer {
  font-weight: 600;
}
app-criminal-grid-table .gridHeaderContainer .defaultSettingHeader {
  flex: 0 1 180px;
}
app-criminal-grid-table .gridHeaderContainer .offsenseNameHeader {
  flex: 0 1 40%;
}
app-criminal-grid-table .gridHeaderContainer .howManyAllowedHeader {
  flex: 0 1 280px;
}
app-criminal-grid-table .gridHeaderContainer .howLongHeader {
  flex: 0 1 190px;
}
app-criminal-grid-table .gridHeaderContainer .decisionHeader {
  flex: 0 1 270px;
}
app-criminal-grid-table .gridHeaderContainer .buttonHeader {
  flex: 0 1 70px;
}
`, "",{"version":3,"sources":["webpack://./src/app/decision-grid/Components/criminal-grid-table/criminal-grid-table.component.less"],"names":[],"mappings":"AAAA;EAGI,qBAAA;EAGA,iBAAA;EACA,mBAAA;AAHJ;AAJA;EAYI,yBAAA;EACA,UAAA;AALJ;AARA;EAkBI,aAAA;EACA,mBAAA;EAEA,iBAAA;EACA,oBAAA;AARJ;AAdA;EAyBM,gBAAA;AARN;AAjBA;EA6BM,eAAA;AATN;AApBA;EAkCQ,aAAA;AAXR;AAvBA;EAsCM,eAAA;AAZN;AA1BA;EA0CM,eAAA;AAbN;AA7BA;EA8CM,eAAA;AAdN;AAhCA;EAkDM,cAAA;AAfN","sourcesContent":["app-criminal-grid-table {\n\n  .settingsContainer {\n    border-top: 1px solid;\n    // border-bottom: 1px solid;\n\n    padding-top: 20px;\n    padding-bottom: 2px;\n\n  }\n\n  .mat-tab-label {\n    background-color: #e6e4e6;\n    width: 50%;\n  }\n\n  .gridHeaderContainer {\n\n    display: flex;\n    flex-direction: row;\n\n    padding-top: 20px;\n    padding-bottom: 20px;\n\n    .headerContainer {\n      font-weight: 600;\n    }\n\n    .defaultSettingHeader {\n      flex: 0 1 180px;\n    }\n\n    .offsenseNameHeader {\n      // flex: 1;\n        flex: 0 1 40%;\n    }\n\n    .howManyAllowedHeader {\n      flex: 0 1 280px;\n    }\n\n    .howLongHeader {\n      flex: 0 1 190px;\n    }\n\n    .decisionHeader {\n      flex: 0 1 270px;\n    }\n\n    .buttonHeader {\n      flex: 0 1 70px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
